module.exports = __webpack_public_path__ + "img/bball_ranks_2016_ss.145aa52f.png";